import Reviewstars from "../../UI/reviewStars/reviewstars";
import CheckboxReview from "./TestiReview/checkboxReview";
import { Col,Row } from "react-bootstrap";
import "./testiOrders.css";
import React from "react";

export const TestiOrders = (props) => {
  const { data } = props.data;
  const productsOrdered = () => {
    return data.products?.map((product, index) => {
      return (
          <Row key={product.id} className="productsContainer">
            <div className="productName">{product.name}</div>
            <Col md="3" lg="2" xl="auto"  className="productImage" >
              <img
                className="testiPhoto"
                src={
                  product.thumbnail
                }
                alt={product.name}
              />
            </Col>
            <Col md="8" lg="9" xl="auto" className="productReview"> 
              <CheckboxReview id={product.id} key={'Checkbox'+index} />
              <Reviewstars id={product.id} key={'ReviewStars'+index} />
            </Col>
          </Row>
      );
    });
  };
  return (
    <div className="tesimonial_orders_header">
      <h1>List of Flowers Ordered</h1>
      {productsOrdered()}
    </div>
  );
};
